import {useState} from 'react';
import FloatingOnlySelectBottomSheet from '../../../../../../../module/newShop/advertisementRegisteration/floatingOnlySelectBottomSheet';
import {BottomSheet} from 'react-spring-bottom-sheet';
import CustomRadio from '../../../../../../../components/mazraeKit/customRadio';
import {useFormikContext} from 'formik';
import {FromikType} from '../../../../types';

interface IProps {
  guid: string;
  title: string;
}

interface IDropBottomSheetWithRadioProps {
  data: Array<{guid: string; title: string}>;
  name: string;
  placeholder?: string;
  onChange: ({guid, title}: IProps) => void;
  value?: string;
  checked?: boolean;
}

function DropBottomSheetWithRadio({
  data,
  name,
  placeholder,
  onChange,
  value,
}: IDropBottomSheetWithRadioProps) {
  const [openBottomSheet, setOpenBottomSheet] = useState<boolean>(false);
  const {values} = useFormikContext<FromikType>();

  return (
    <div className="flex flex-col w-full">
      <FloatingOnlySelectBottomSheet
        Placeholder={placeholder}
        name={name}
        wrapperClass="border-gray-700"
        onClick={() => {
          setOpenBottomSheet(true);
        }}
        //@ts-ignore
        value={values[name]?.title}
      />
      <BottomSheet
        onDismiss={() => setOpenBottomSheet(false)}
        open={openBottomSheet}
        blocking={true}
        snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.6]}
      >
        <div className="flex flex-col gap-2 p-4 pt-3">
          {data?.map(item => {
            return (
              <CustomRadio
                key={item.guid}
                name={name}
                value={item.guid}
                title={item.title}
                //@ts-ignore
                checked={item.guid === values[name]?.guid}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  onChange(item);
                  setOpenBottomSheet(false);
                }}
              />
            );
          })}
        </div>
      </BottomSheet>
    </div>
  );
}

export default DropBottomSheetWithRadio;
